import API_ENDPOINTS from "@/common/api/apiEndpoints";
import httpClient from "@/common/api/httpClient";
import httpMethods from "@/common/api/httpMethods";
import type { TestPlanScheduleParams } from "@/common/types/TestCase";

export const fetchBrowserList = (id: string) =>
  httpClient(
    httpMethods.GET,
    `${API_ENDPOINTS.DASHBOARD.browserList}${encodeURIComponent(id)}`,
  );

export const fetchFilteredTestCases = (id: string) =>
  httpClient(
    httpMethods.GET,
    `${API_ENDPOINTS.DASHBOARD.filteredTestCases}${encodeURIComponent(id)}`,
  );

export const fetchTestCaseStatus = (id: string) =>
  httpClient(
    httpMethods.GET,
    `${API_ENDPOINTS.DASHBOARD.testCaseStatus}${encodeURIComponent(id)}`,
  );

export const fetchDefectStatus = (id: string) =>
  httpClient(
    httpMethods.GET,
    `${API_ENDPOINTS.DASHBOARD.defectStatus}${encodeURIComponent(id)}`,
  );

export const fetchActiveTestCaseRun = (id: string) =>
  httpClient(
    httpMethods.GET,
    `${API_ENDPOINTS.DASHBOARD.activeTestCaseRun}${encodeURIComponent(id)}`,
  );

export const fetchRecentlyFailedTestCases = (filterId: string) => {
  const endpoint = `${API_ENDPOINTS.DASHBOARD.recentlyFailedTestCases}${filterId}`;
  return httpClient(httpMethods.GET, endpoint);
};

export const fetchTestPlanSchedule = (params: TestPlanScheduleParams) => {
  const query = new URLSearchParams(params as any).toString();
  return httpClient(
    httpMethods.GET,
    `${API_ENDPOINTS.DASHBOARD.testPlanSchedule}?${query}`,
  );
};

export const fetchProjectsList = (params?: Record<string, any>) => {
  const query = params
    ? `?${new URLSearchParams(
        Object.fromEntries(
          Object.entries(params).filter(
            ([, v]) => v !== undefined && v !== null,
          ),
        ) as Record<string, string>,
      ).toString()}`
    : "";
  const endpoint = `${API_ENDPOINTS.WORKSPACE.project}${query}`;
  return httpClient(httpMethods.GET, endpoint);
};

export const fetchWorkspacesList = (projectId: string) => {
  const endpoint = `${API_ENDPOINTS.WORKSPACE.workspace}projectid/${encodeURIComponent(projectId)}?sort=name,asc`;
  return httpClient(httpMethods.GET, endpoint);
};

export const fetchVersionsList = (workspaceId: string) => {
  const endpoint = `${API_ENDPOINTS.WORKSPACE.version}${workspaceId}`;
  return httpClient(httpMethods.GET, endpoint);
};

/** Fetch ALL projects in the current user's organisation — for invite/bulk-invite forms. */
export const fetchOrgProjectsApi = (options: { excludeSample?: boolean } = {}) =>
  httpClient(
    httpMethods.GET,
    `${API_ENDPOINTS.WORKSPACE.project}/org${options.excludeSample ? "?excludeSample=true" : ""}`,
  );
